import React from 'react';

interface FooterProps {
  updatedAt?: string;
  isActive?: boolean;
}

export default function Footer({ updatedAt, isActive }: FooterProps) {
  const currentYear = new Date().getFullYear();

  const formatUpdateTime = (timestamp?: string) => {
    if (!timestamp) return 'Never';

    try {
      const date = new Date(timestamp);
      return date.toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short',
      });
    } catch {
      return 'Invalid date';
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          {typeof isActive !== 'undefined' && (
            <p className={`competition-status ${isActive ? 'active' : 'inactive'}`}>
              {isActive ? '✓ Competition is currently active' : '⚠ Competition is inactive'}
            </p>
          )}
          {updatedAt && (
            <p className="last-updated">
              Last updated: {formatUpdateTime(updatedAt)}
            </p>
          )}
          <p className="copyright">
            &copy; {currentYear} Proper Wild. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
